"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2098],{

/***/ 6624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AdBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32223);



function AdBanner(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        py: 4,
        m: "auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            maxWidth: 728,
            children: children
        })
    });
};


/***/ }),

/***/ 36468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AdBox; },
  "j": function() { return /* binding */ AdContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(37138);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
;// CONCATENATED MODULE: ./src/components/AdContent/AdBox.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  justify-content: center;\n  height: 250px;\n  width: 100%;\n  margin: 0 16px 0 0;\n  max-width: 474px;\n  min-width: 300px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    justify-content: center;\n    height: 250px;\n    width: 100%;\n    margin: 0 16px 0 0;\n    max-width: 474px;\n    min-width: 300px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 250px;\n  width: 300px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var PrimaryWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-502d5506-0"
})(_templateObject());
var SecondaryWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-502d5506-1"
})(_templateObject1(), (0,index_esm/* themeGet */.R)('mediaQueries.xl'));
var TertiaryWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-502d5506-2"
})(_templateObject2());
var AdBoxWrapper = {
    primary: PrimaryWrapper,
    secondary: SecondaryWrapper,
    tertiary: TertiaryWrapper
};
function AdBox(param) {
    var children = param.children, type = param.type;
    var Wrapper = AdBoxWrapper[type];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            width: 1,
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/AdContent/index.tsx




function AdContent(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "center",
        m: 4,
        children: children
    });
}



/***/ }),

/***/ 9438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pcln_vip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90370);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80404);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var AppDownloadWrapper = function(_param) {
    var category = _param.category, props = _objectWithoutProperties(_param, [
        "category"
    ]);
    var gaAppDownload = function(device) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: 'app download',
            category: category,
            label: device
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_vip__WEBPACK_IMPORTED_MODULE_3__/* .AppDownload */ .B, _objectSpread({
        gaTracking: gaAppDownload
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppDownloadWrapper);


/***/ }),

/***/ 4037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BundleAndSave; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92833);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23720);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98028);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67905);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var pcln_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72027);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80404);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var FlexWrapper = function(param) {
    var children = param.children, isStickySearch = param.isStickySearch, isSubmitButtonReplacement = param.isSubmitButtonReplacement;
    var flexProps = !isStickySearch && {
        p: 1,
        mt: isSubmitButtonReplacement ? 0 : [
            0,
            3,
            null,
            null,
            0
        ],
        mr: [
            2,
            0
        ],
        borderRadius: 'lg',
        height: '100%',
        color: 'highlight.light'
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
        alignItems: "center"
    }, flexProps, {
        children: children
    }));
};
function BundleAndSave(param) {
    var category = param.category, productOptions = param.productOptions, tripType = param.tripType, label = param.label, setValue = param.setValue, _color = param.color, color = _color === void 0 ? 'gray' : _color, _isStickySearch = param.isStickySearch, isStickySearch = _isStickySearch === void 0 ? false : _isStickySearch, isSubmitButtonReplacement = param.isSubmitButtonReplacement;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), _query = ref.query, _tab = _query.tab, tab = _tab === void 0 ? 'hotels' : _tab, pathname = ref.pathname;
    var isHomepage = pathname === '/';
    var parent = isHomepage ? "".concat(tab, "-") : '';
    var onBundleTypeSelection = function(e, option) {
        var value;
        if (e.target.checked) {
            value = "".concat(tripType, ":").concat(option.type);
            _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
                action: 'Add Product Checkbox',
                category: category,
                label: "".concat(parent).concat(option.label)
            });
        } else {
            value = tripType.replace(":".concat(option.type), '');
        }
        setValue('tripType', value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FlexWrapper, {
            isStickySearch: isStickySearch,
            isSubmitButtonReplacement: isSubmitButtonReplacement,
            children: [
                isStickySearch ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    pr: [
                        1,
                        2,
                        null,
                        3
                    ],
                    fontSize: 0,
                    color: color,
                    children: label
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    style: {
                        flex: '1 1 auto'
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            m: 1,
                            mr: 2,
                            color: isHomepage ? 'highlight.shade' : 'success.dark'
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            pr: [
                                1,
                                2,
                                null,
                                3
                            ],
                            color: isHomepage ? 'highlight.shade' : 'success.dark',
                            bold: true,
                            fontSize: [
                                0,
                                null,
                                null,
                                null,
                                1
                            ],
                            m: "auto",
                            ml: 0,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    style: {
                        flex: '1 0 auto'
                    },
                    flexWrap: "wrap",
                    alignItems: "center",
                    children: productOptions.map(function(option) {
                        var checked = tripType.includes(option.type);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            mt: "2px",
                            pr: [
                                1,
                                2,
                                3
                            ],
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                fontSize: 0,
                                htmlFor: option.id,
                                color: color,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        "aria-label": option.label,
                                        id: option.id,
                                        "data-testid": option.id,
                                        name: option.name,
                                        value: option.type,
                                        checked: checked,
                                        onChange: function(e) {
                                            return onBundleTypeSelection(e, option);
                                        }
                                    }),
                                    " ".concat(option.label, " ")
                                ]
                            })
                        }, option.name);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 71098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Desktop_Desktop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Divider/Divider.js
var Divider = __webpack_require__(11477);
// EXTERNAL MODULE: ./node_modules/@pcln/ad-unit/dist/esm/index.js + 3 modules
var esm = __webpack_require__(6824);
// EXTERNAL MODULE: ./src/components/Heros/HeroImageParallax.tsx
var HeroImageParallax = __webpack_require__(68457);
// EXTERNAL MODULE: ./src/components/StyledHeading/index.tsx
var StyledHeading = __webpack_require__(5527);
// EXTERNAL MODULE: ./src/hooks/useContentfulSearchFormHeadlines.ts
var useContentfulSearchFormHeadlines = __webpack_require__(34752);
// EXTERNAL MODULE: ./src/hooks/useCityNameInFormHeadlineForSEMFlights.ts
var useCityNameInFormHeadlineForSEMFlights = __webpack_require__(61947);
// EXTERNAL MODULE: ./src/components/Flights/SearchForm/Form.tsx + 4 modules
var Form = __webpack_require__(70049);
// EXTERNAL MODULE: ./src/components/AdBanner.tsx
var AdBanner = __webpack_require__(6624);
// EXTERNAL MODULE: ./src/components/AdContent/index.tsx + 1 modules
var AdContent = __webpack_require__(36468);
// EXTERNAL MODULE: ./src/components/AppDownloadWrapper/index.tsx
var AppDownloadWrapper = __webpack_require__(9438);
// EXTERNAL MODULE: ./src/components/EmailSignUp/index.tsx + 7 modules
var EmailSignUp = __webpack_require__(72365);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var analytics = __webpack_require__(92265);
;// CONCATENATED MODULE: ./src/components/Flights/Content/Content.tsx








var Content = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSignUp/* EmailSignUpComponent */.mK, {
                sourceId: "LANDING_AIR",
                category: analytics/* ANALYTICS_CATEGORY_FLIGHTS */.y1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdContent/* AdContent */.j, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdContent/* AdBox */.Z, {
                        type: "primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-testid": "flight-ad-1",
                            id: "div-gpt-ad-1510165758104-0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdContent/* AdBox */.Z, {
                        type: "secondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-testid": "flight-ad-2",
                            id: "div-gpt-ad-1510169021467-0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdContent/* AdBox */.Z, {
                        type: "tertiary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-testid": "flight-ad-3",
                            id: "div-gpt-ad-1510169161509-0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    color: "background.light",
                    boxShadowSize: "sm",
                    borderRadius: "xl",
                    mx: 4,
                    pr: [
                        3,
                        null,
                        null,
                        null,
                        4,
                        5
                    ],
                    pl: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDownloadWrapper/* default */.Z, {
                        category: analytics/* ANALYTICS_CATEGORY_FLIGHTS */.y1
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdBanner/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-testid": "flight-ad-4",
                    id: "div-gpt-ad-1510169283152-0"
                })
            })
        ]
    });
};
/* harmony default export */ var Content_Content = (Content);

;// CONCATENATED MODULE: ./src/components/Flights/Content/index.tsx


// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./src/hooks/useExpressDealModal.ts
var useExpressDealModal = __webpack_require__(68556);
// EXTERNAL MODULE: ./src/components/Flights/ExpressDeal/ExpressDealModal.tsx
var ExpressDealModal = __webpack_require__(4083);
;// CONCATENATED MODULE: ./src/components/Flights/ExpressDeal/ExpressDealBanner.tsx





function ExpressDealBanner() {
    var ref = (0,useExpressDealModal/* default */.Z)(), isOpen = ref.isOpen, openModal = ref.openModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        color: "background.light",
        onClick: openModal,
        p: 3,
        tabIndex: "0",
        width: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                color: "background.light",
                justifyContent: "center",
                flexWrap: "wrap",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        fontSize: 1,
                        textAlign: "center",
                        color: "text.dark",
                        children: "Want even bigger discounts? Save up to 50% by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        fontSize: 1,
                        color: "primary",
                        pl: 1,
                        children: "searching Express Deals"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        fontSize: 1,
                        textAlign: "center",
                        color: "text.dark",
                        children: "."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpressDealModal/* default */.Z, {
                isModalOpen: isOpen
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Flights/SearchForm/utils.ts
var utils = __webpack_require__(31865);
// EXTERNAL MODULE: ./src/components/Flights/constants.ts
var constants = __webpack_require__(83016);
;// CONCATENATED MODULE: ./src/components/Flights/Desktop/Desktop.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 1;\n  display: block;\n  height: auto;\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: none;\n  text-align: center;\n  position: relative;\n  margin: 16px;\n  min-height: 100px;\n  ",
        " {\n    width: 300px;\n    margin: 0 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var BlockFlex = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-d98551f2-0"
})(_templateObject(), theme/* theme.mediaQueries.3 */.rS.mediaQueries[3]);
var HideFlexNone = (0,styled_components_browser_esm/* default */.ZP)(Hide/* default */.Z).withConfig({
    componentId: "sc-d98551f2-1"
})(_templateObject1(), theme/* theme.mediaQueries.3 */.rS.mediaQueries[3]);
var Desktop = function() {
    var searchForm = (0,useContentfulSearchFormHeadlines/* default */.Z)('searchForm');
    var semPrepopHeadline = (0,useCityNameInFormHeadlineForSEMFlights/* default */.Z)();
    var headingValue = semPrepopHeadline || (searchForm === null || searchForm === void 0 ? void 0 : searchForm.headline) || constants/* PRIMARY_HEADING_FALLBACK */.kt;
    var subHeadingValue = (searchForm === null || searchForm === void 0 ? void 0 : searchForm.subheadline) || constants/* SECONDARY_HEADING_FALLBACK */.i$;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        "data-testid": "flights-desktop",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroImageParallax/* default */.Z, {
                isScrollable: true,
                gptId: "div-gpt-ad-1510165335112-0",
                slot: "/3102/priceline.dart/air_homepage_hero_image",
                mb: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: 1280,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockFlex, {
                        mx: 3,
                        py: [
                            3,
                            null,
                            null,
                            null,
                            5
                        ],
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                    borderWidth: 0,
                                    color: "background.lightest",
                                    borderRadius: "2xl",
                                    boxShadowSize: "xl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            p: [
                                                3,
                                                4
                                            ],
                                            width: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    flexDirection: "column",
                                                    mb: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                                                            text: headingValue,
                                                            textStyle: "heading2",
                                                            color: "text.heading",
                                                            tag: "h1"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                                                            color: "text.light",
                                                            textStyle: "subheading4",
                                                            text: subHeadingValue,
                                                            tag: "h2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                                                    onSubmit: utils/* onSubmit */.MI
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hide/* default */.Z, {
                                            xs: true,
                                            sm: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                    m: 0
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    color: "background.light",
                                                    borderRadius: "2xl",
                                                    boxShadowSize: "xl",
                                                    rounded: "bottom",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpressDealBanner, {})
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HideFlexNone, {
                                xs: true,
                                sm: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Gpt */.B, {
                                    render: function() {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "div-gpt-ad-1510165683878-0"
                                        });
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                xs: true,
                sm: true,
                color: "background.lightest",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Content, {})
            })
        ]
    });
};
/* harmony default export */ var Desktop_Desktop = (Desktop);

;// CONCATENATED MODULE: ./src/components/Flights/Desktop/index.tsx



/***/ }),

/***/ 4083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ExpressDealModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70960);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92591);
/* harmony import */ var _components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5527);
/* harmony import */ var _hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68556);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92265);
/* harmony import */ var _constants_content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66466);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83016);
/* harmony import */ var _SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31865);
/* harmony import */ var _SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70049);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











/**
 * TODO: Add fallback in StyleHeading, please refer
 * commit history for fallback text
 */ function ExpressDealModal(param) {
    var isModalOpen = param.isModalOpen, _gaCategory = param.gaCategory, gaCategory = _gaCategory === void 0 ? _constants_analytics__WEBPACK_IMPORTED_MODULE_4__/* .ANALYTICS_CATEGORY_FLIGHTS */ .y1 : _gaCategory, _qsKey = param.qsKey, qsKey = _qsKey === void 0 ? 'modal' : _qsKey, _qsValue = param.qsValue, qsValue = _qsValue === void 0 ? 'express-deals' : _qsValue;
    var closeModal = (0,_hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(qsKey, qsValue).closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        isOpen: isModalOpen,
        onClose: closeModal,
        width: [
            1,
            750
        ],
        enableOverflow: true,
        timeout: 50,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            p: [
                3,
                0
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    px: [
                        0,
                        3
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.flights.expressDeals.headline */ .ZP.homepage.flights.expressDeals.headline,
                            fontSize: [
                                3,
                                null,
                                null,
                                5
                            ],
                            lineHeight: "display",
                            tag: "h1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.flights.expressDeals.subHeadline */ .ZP.homepage.flights.expressDeals.subHeadline,
                            fontSize: [
                                1,
                                null,
                                null,
                                4
                            ],
                            mb: 3,
                            lineHeight: "display",
                            tag: "h2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    pb: 4,
                    px: [
                        0,
                        3
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        onSubmit: function(values) {
                            return (0,_SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__/* .onSubmitExpressDeal */ .pZ)(_objectSpread({}, values, {
                                gaCategory: gaCategory
                            }));
                        },
                        promoDeal: true,
                        flightTypes: [
                            _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_INFO */ .Yt[_constants__WEBPACK_IMPORTED_MODULE_6__/* .ROUND_TRIP */ .iF],
                            _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_INFO */ .Yt[_constants__WEBPACK_IMPORTED_MODULE_6__/* .ONE_WAY */ .KW]
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 68457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7981);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70564);
/* harmony import */ var _pcln_ad_unit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6824);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  overflow: hidden;\n  pointer-events: none;\n  position: ",
        ";\n  left: 0;\n  top: 0;\n  z-index: -1;\n\n  & iframe {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  z-index: -2;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BackgroundWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-865b7cee-0"
})(_templateObject(), function(props) {
    return props.isScrollable ? 'absolute' : 'fixed';
}, function(props) {
    return props.height;
});
var StyledAbsolute = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-865b7cee-1"
})(_templateObject1());
function HeroImageParallax(_param) {
    var children = _param.children, gptId = _param.gptId, slot = _param.slot, _isScrollable = _param.isScrollable, isScrollable = _isScrollable === void 0 ? false : _isScrollable, props = _objectWithoutProperties(_param, [
        "children",
        "gptId",
        "slot",
        "isScrollable"
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), height = ref2[0], setHeight = ref2[1];
    var currentContaineNodeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var calculateHeight = function() {
            var ref, ref1;
            var headerHeight = ((ref = document.getElementById('exp-hdr')) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
            var heroContainerHeight = (currentContaineNodeRef === null || currentContaineNodeRef === void 0 ? void 0 : (ref1 = currentContaineNodeRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight) || 0;
            return headerHeight + heroContainerHeight;
        };
        var setHeightThrottled = lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(function() {
            setHeight(calculateHeight());
        }, 100);
        if (currentContaineNodeRef && currentContaineNodeRef.current) {
            window.addEventListener('resize', setHeightThrottled);
            var heroContainer = currentContaineNodeRef.current;
            var config = {
                attributes: true,
                childList: true,
                subtree: true
            };
            var observer = new MutationObserver(setHeightThrottled);
            observer.observe(heroContainer, config);
            return function() {
                window.removeEventListener('resize', setHeightThrottled);
                observer.disconnect();
            };
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({
        ref: currentContaineNodeRef
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledAbsolute, {
                color: "primary.dark"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackgroundWrapper, {
                width: 1,
                height: height,
                isScrollable: isScrollable,
                className: "HeroImageParallax",
                "data-testid": "hero-image-parallax",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_ad_unit__WEBPACK_IMPORTED_MODULE_3__/* .Gpt */ .B, {
                    render: function() {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_ad_unit__WEBPACK_IMPORTED_MODULE_3__/* .GptProcessor */ .o, {
                            slot: slot,
                            gptId: gptId,
                            sizeMap: [
                                'fluid'
                            ]
                        });
                    }
                })
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (HeroImageParallax);


/***/ }),

/***/ 33271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ onSubmit; },
/* harmony export */   "GS": function() { return /* binding */ getTextString; },
/* harmony export */   "k7": function() { return /* binding */ CALENDAR_POPOVER_SELECTOR; },
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "XU": function() { return /* binding */ fields; }
/* harmony export */ });
/* harmony import */ var _shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62599);
/* harmony import */ var _shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34917);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80404);
/* harmony import */ var _TripTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6244);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var onSubmit = function(values) {
    var ANALYTICS_CATEGORY = values.gaCategory;
    var startLocation = values.startLocation, endLocation = values.endLocation, childrenAges = values.childrenAges, rest = _objectWithoutProperties(values, [
        "startLocation",
        "endLocation",
        "childrenAges"
    ]);
    var isPartialStayDateValid = !!rest.partialStay && (rest.hotelStartDate !== rest.startDate || rest.hotelEndDate !== rest.endDate);
    if ((startLocation === null || startLocation === void 0 ? void 0 : startLocation.type) === 'AIRPORT' && (startLocation === null || startLocation === void 0 ? void 0 : startLocation.lat) === 0 && (startLocation === null || startLocation === void 0 ? void 0 : startLocation.lon) === 0) {
        startLocation.type = 'GDS_CITY';
    }
    if ((endLocation === null || endLocation === void 0 ? void 0 : endLocation.type) === 'AIRPORT' && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.lat) === 0 && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.lon) === 0) {
        endLocation.type = 'GDS_CITY';
    }
    (0,_shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread({
        startLocationObject: startLocation,
        endLocationObject: endLocation,
        childrenAges: childrenAges
    }, rest, {
        isPartialStayDateValid: isPartialStayDateValid && rest.tripType !== _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_DRIVE */ .Hl
    }));
    (0,_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__/* .persistSearchData */ .al)(_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__/* .PACKAGE_SEARCH_DATA */ .Tw, values);
    if (isPartialStayDateValid) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: 'VP Search Button',
            label: 'Partial search'
        });
    }
    if (rest.isRecommendedTrip) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: 'VP Search Button',
            label: 'Recommended Trip search'
        });
    }
    if (!isPartialStayDateValid && !rest.isRecommendedTrip) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            category: ANALYTICS_CATEGORY,
            action: 'VP Search Button',
            label: 'Normal search'
        });
    }
    if (rest.pickupCarSomewhere) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: 'H+C - Different Location Search',
            category: ANALYTICS_CATEGORY
        });
    }
    if (!rest.pickupCarIncludeAirport) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: 'Hide On Airport Inventory',
            category: ANALYTICS_CATEGORY
        });
    }
};

var getTextString = function(tripType) {
    return function(text) {
        switch(tripType){
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY_DRIVE */ .Ss:
                return "".concat(text, "hotel, flight and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .FLY_DRIVE */ .yv:
                return "".concat(text, "flight and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_DRIVE */ .Hl:
                return "".concat(text, "hotel and car");
            case _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY */ .b:
            default:
                return "".concat(text, "hotel and flight");
        }
    };
};
var CALENDAR_POPOVER_SELECTOR = '[aria-label="Calendar navigation tooltip"]';
var initialState = {
    tripType: _TripTypes__WEBPACK_IMPORTED_MODULE_3__/* .STAY_FLY */ .b,
    partialStay: false,
    startLocation: null,
    endLocation: null,
    startDate: '',
    endDate: '',
    hotelStartDate: '',
    hotelEndDate: '',
    roomCount: 1,
    adultCount: 2,
    childrenCount: 0,
    childrenAges: [],
    isRecommendedTrip: false,
    includeBasicEconomy: true,
    pickupCarSomewhere: false,
    pickupCarIncludeAirport: true,
    rcLocation: null,
    rcPickupDate: '',
    rcDropoffDate: '',
    rcPickupTime: '10:00',
    rcDropoffTime: '10:00',
    gaCategory: ''
};
var fields = [
    'startLocation',
    'endLocation',
    'startDate',
    'endDate',
    'hotelStartDate',
    'hotelEndDate',
    'roomCount',
    'adultCount',
    'childrenCount',
    'childrenAges',
    'tripType',
    'includeBasicEconomy',
    'pickupCarSomewhere',
    'pickupCarIncludeAirport',
    'rcLocation',
    'rcPickupDate',
    'rcDropoffDate',
    'rcPickupTime',
    'rcDropoffTime',
    'gaCategory'
];


/***/ }),

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StyledHeading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99278);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97331);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23720);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1377);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h1 */ .Z.h1).withConfig({
    componentId: "sc-ca43ae5a-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .textAlign */ .yd);
var StyledH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h2 */ .Z.h2).withConfig({
    componentId: "sc-ca43ae5a-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .alignSelf */ .uk, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .textAlign */ .yd, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .fontWeight */ .Ue, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .space */ .Dh);
var HEADINGS = {
    h1: StyledH1,
    h2: StyledH2
};
function StyledHeading(_param) {
    var _color = _param.color, color = _color === void 0 ? 'text.base' : _color, text = _param.text, _fontSize = _param.fontSize, fontSize = _fontSize === void 0 ? [
        3,
        4,
        null,
        5
    ] : _fontSize, textAlign = _param.textAlign, tag = _param.tag, textStyle = _param.textStyle, props = _objectWithoutProperties(_param, [
        "color",
        "text",
        "fontSize",
        "textAlign",
        "tag",
        "textStyle"
    ]);
    var Component = HEADINGS[tag];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var bold = isMobile ? '600' : '700';
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({
        fontSize: fontSize,
        fontWeight: tag === 'h2' ? '400' : bold,
        textAlign: textAlign || 'left',
        color: color,
        textStyle: textStyle,
        m: 0
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            children: text
        })
    }));
};


/***/ }),

/***/ 66466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gL": function() { return /* binding */ GREETING_DESKTOP; }
/* harmony export */ });
/* unused harmony export GREETING_MOBILE */
var GREETING_MOBILE = 'Welcome to Priceline';
var GREETING_DESKTOP = 'Welcome to Priceline';
var Content = {
    homepage: {
        hotel: {
            signedInSubHeading: 'You qualify for VIP hotel deals! Search and save.',
            expressDeals: {
                headline: 'Search for Express Deals',
                subHeadline: 'Save up to 60% Fast and Easy - No Bidding Required!'
            }
        },
        flights: {
            expressDeals: {
                headline: 'Search for Express Deals',
                subHeadline: 'Save up to 50% on trusted airlines!'
            }
        },
        vip: {
            defaultHeading: GREETING_MOBILE,
            headlineWithName: 'Welcome, {firstName}',
            promo: {
                headline: 'You qualify for hotel discounts of up to 50% as a VIP member!',
                headlineWithName: '{firstName}, you qualify for hotel discounts of up to 50% as a VIP member!',
                subHeadline: 'Book Priceline VIP deals for your exclusive savings'
            }
        }
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (Content);


/***/ }),

/***/ 61947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCityNameInFormHeadlineForSEMFlights; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1377);
/* harmony import */ var _useSeti__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22091);



function useCityNameInFormHeadlineForSEMFlights() {
    var ref, ref1, ref2, ref3;
    var prePopData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).prePopData;
    var cityName = prePopData === null || prePopData === void 0 ? void 0 : (ref = prePopData.flights) === null || ref === void 0 ? void 0 : (ref1 = ref.flights) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.endLocation) === null || ref3 === void 0 ? void 0 : ref3.cityName;
    var FLIGHTS_LP_SEM_CITY_HEADING = (0,_useSeti__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('FLIGHTS_LP_SEM_CITY_HEADING', !!cityName);
    return FLIGHTS_LP_SEM_CITY_HEADING === 'VARIANT' && !!cityName ? "Fly to ".concat(cityName, " with confidence") : '';
};


/***/ }),

/***/ 25439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useContent; }
/* harmony export */ });
/* harmony import */ var _pcln_contentful_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57931);
/* harmony import */ var _useSeti__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22091);


function useContent(item) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var setiName = (0,_useSeti__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item === null || item === void 0 ? void 0 : item.experimentName, shouldFireImpression && (item === null || item === void 0 ? void 0 : item.experimentName) !== undefined);
    return (item === null || item === void 0 ? void 0 : item.experimentName) ? (0,_pcln_contentful_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(setiName, item) : item;
};


/***/ }),

/***/ 34752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useContentfulSearchFormHeadlines; }
/* harmony export */ });
/* harmony import */ var _pcln_contentful_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61388);
/* harmony import */ var _useContent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25439);


function useContentfulSearchFormHeadlines(name) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var searchFormResponse = (0,_pcln_contentful_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(name);
    var searchForm = (0,_useContent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(searchFormResponse, shouldFireImpression);
    return searchForm !== null && searchForm !== void 0 ? searchForm : null;
};


/***/ }),

/***/ 68556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExpressDealModal; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77584);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


function useExpressDealModal() {
    var qsKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'modal', qsValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'express-deals';
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var query = router.query, pathname = router.pathname;
    var isOpen = query[qsKey] === qsValue;
    var openModal = function() {
        router.push({
            pathname: pathname,
            query: _objectSpread({}, query, _defineProperty({}, qsKey, qsValue))
        }, undefined, {
            shallow: true
        });
    };
    var closeModal = function() {
        router.push({
            pathname: pathname,
            query: (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
                qsKey
            ], query)
        }, undefined, {
            shallow: true
        });
    };
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: closeModal
    };
};


/***/ })

}]);